import React from 'react';
import {
  Box,
  Heading,
  Flex
} from '@chakra-ui/react';
import ClgBg from './images/college.jpg';

export default function Contact() {

  return (
    <Flex
      align="center"
      justify="center"
      css={{
        backgroundImage: 'linear-gradient(to bottom, rgba(0,0,0,0.7) 0%,rgba(0,0,0,0.7) 100%), url(' + ClgBg + ')',
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundAttachment: 'fixed',
        backgroundPosition: 'center',
        height: '500px'
      }}
      id="contact">
      <Box
        borderRadius="lg"
        m={{ base: 8, md: 10, lg: 10 }}
        p={{ base: 5, lg: 10 }}
        textAlign={'center'}>
        <Heading color={'white'} fontSize={{ base: '6xl', md: '8xl' }}>Venue</Heading>
        <br />

        <a href='https://maps.app.goo.gl/ipQcPKoDgvVz8QdG9' target="_blank" rel="noreferrer">
          <Heading color={'white'} fontSize={{ base: '2xl', md: '4xl' }}>NH-3, Near Crossing Republik, Ghaziabad, Uttar Pradesh 201009</Heading>
        </a>

      </Box>
    </Flex>
  );
}